export default "__VITE_ASSET__g51ovXY6__"